module.exports = __webpack_public_path__ + "c4436902431432cb29a77c35f2b53dae.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/web-links/2.jpg
// module id = ./assets/images/web-links/2.jpg
// module chunks = 0